import { gql } from "@apollo/client";

export const CREATE_SELF_SOC = gql`
  mutation createSelfSoc($addSelfSocData: SelfSocInput!) {
    createSelfSoc(data: $addSelfSocData) {
      selfSoc {
        animalId
        fulfilledDate
        fulfilledDateISO
        eventName
      }
      success
      messages
    }
  }
`;

export const SOC_DATA_BY_PETS = gql`
query($ids: [String!]!) {
  socByPetId(socByPets: { animalIds: $ids }) {
    success
    messages
    pets {
      items {
        vaccination {
          id
          name
          lastGiven
          nextDose
          status
          vetName
          details {
            title
            description
          }
          lastGivenIso
          nextDoseIso
          type
        }
        dental {
          id
          name
          lastGiven
          nextDose
          status
          vetName
          details {
            title
            description
          }
          lastGivenIso
          nextDoseIso
          type
        }
        diagnostic {
          id
          name
          lastGiven
          nextDose
          status
          vetName
          details {
            title
            description
          }
          lastGivenIso
          nextDoseIso
          type
        }
      }
      animalId
    }
  }
}
`;

export const PET_CARE = gql`
query ($id: String!){
  getGeneralCareByPetV2(id: $id){
     success
     messages

       pets{
      id
      name
      image
      speciesName
      species
      breed
      breedName
      birthdate
      gender
      age
      socStatus
      medicalRecord{
                city
                clinicName
                createdAt
            }
      isDesexed
      idColor
      colorName
      microchip{
        microchipNumber
        details{
          title
          description
        }
      }

          items {
    isPastAppointments
     prescription{
        id
        name
        dose
        indications
        issuedOn
        expiredOn
        quantity
        vetName
        vetDate
        state
      }
      vaccination{
        id
        name
        lastGiven
        nextDose
        status
        vetName
        details{
          title
          description
        }
          lastGivenIso
          nextDoseIso
          type
      }
      dental{
          id
        name
        lastGiven
        nextDose
        status
        vetName
        details{
          title
          description
        }
          lastGivenIso
          nextDoseIso
          type
      }
      diagnostic{
           id
        name
        lastGiven
        nextDose
        status
        vetName
        details{
          title
          description
        }
          lastGivenIso
          nextDoseIso
          type
      }
      preventativeMedication{
          id
        name
        lastGiven
        nextDose
        status
        vetName
        details{
          title
          description
        }
          lastGivenIso
          nextDoseIso
          type
          fullfilledMonths{
          monthName
          monthIndex
          year
          status
          fulfilledDate
        }
      }
      wellnessPlanStatus
      pastAppointments{
        id
        active
        start_at
        dateTime
        duration
        status
        description
        destination_address
        pet{
            id
            name
            image
            speciesName
            species
            breed
            breedName
            birthdate
            gender
            medicalRecord{
                city
                clinicName
                createdAt
            }
        }
            tasks{
            description
            type
            }
            location{
            idLocation
            locationName
            address
            city
            state
            status
            position{
                lat
                lng
            }
            email
            phoneNumber
            timeZone
            background
            }
            reasonsForVisit
            appointmentType
            appointmentTypeId
            allowedToEdit
            feedback {
              questionId
              question
              subText
              answer
              socQuestion
              socSubText
            }
            resources {
              id
              name
            }
            underFeedbackDays
         }
    }
}

}
}`;
